import { render, staticRenderFns } from "./SingleSelectChoice.vue?vue&type=template&id=e17abade&scoped=true"
import script from "./SingleSelectChoice.vue?vue&type=script&lang=js"
export * from "./SingleSelectChoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e17abade",
  null
  
)

export default component.exports